// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"2dbeb1e4","152":"21aa4fcc","313":"da743bdd","322":"702bd3ca"}[chunkId] + ".chunk.js";
};